<template>
	<div class="pa-6">
		<AsiContentContainer :columns="2" no-margin>
			<div>
				<CustomerCardDefaultShipmentType :customer="customer" @change="customerChanged" />
			</div>
			<div>
				<CustomerCardDefaultPaymentType :customer="customer" @change="customerChanged" />
			</div>
		</AsiContentContainer>
	</div>
</template>

<script lang="ts">
	import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
	import {ICustomerShop} from "@/models/customer/CustomerShopModels";
	import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
	import CustomerCardDefaultShipmentType from "@/components/customer/shop/CustomerCardDefaultShipmentType.vue";
	import CustomerCardDefaultPaymentType from "@/components/customer/shop/CustomerCardDefaultPaymentType.vue";

	@Component({
		components: {CustomerCardDefaultPaymentType, CustomerCardDefaultShipmentType, AsiContentContainer}
	})
	export default class CustomerTabSettings extends Vue {

		@Prop({type: Object, required: true})
		public customer!: ICustomerShop;

		@Emit('customerChanged')
		public customerChanged(): void {
			return;
		}
	}
</script>

<style scoped lang="scss">

</style>
